import { ChangeDetectorRef, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { HeaderStyleService, HIDE_HEADER } from '@app/shared/services/header-style.service'

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(
    private router: Router,
    private headerStyleService: HeaderStyleService
  ) {}

  subscribeToNavigationMessages(cdr?: ChangeDetectorRef) {
    window.addEventListener('message', (event) => {
      this.navigateByAction(event.data.action, event.data.id, cdr)
    })
  }

  navigateByAction(action: string, id: number, cdr?: ChangeDetectorRef) {
    switch (action) {
      case 'goToScopes':
        this.router.navigateByUrl('/scopes')
        break
      case 'goToScope':
        this.router.navigateByUrl(`/scopes/scope-overview/${id}`)
        break
      case 'goToScopeByRole':
        this.router.navigateByUrl(`/scopes/scope-by-role-overview/${id}`)
        break
      case 'goToFolders':
        this.router.navigate(['/scopes'], { queryParams: { tab: 'folders' } })
        break
      case 'goToFolder':
        this.router.navigateByUrl(`/scopes/folder-overview/${id}`)
        break
      case 'goToRetainedTeam':
        this.headerStyleService.setHeaderClass(HIDE_HEADER)
        cdr.markForCheck()
        break
      case 'goOutRetainedTeam':
        this.headerStyleService.setHeaderClass(null)
        cdr.markForCheck()
        break
    }
  }
}
